(function() { window.GUID_f74d7092_85e5_4e43_8b68_e3ebe1712e8d = { getGuid: function() { return "f74d7092-85e5-4e43-8b68-e3ebe1712e8d"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Stepper extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnBindEvents() {
            }
            OnDispose() {
            }
        }
        Controls.Stepper = Stepper;
        (function (Stepper) {
            let Button;
            (function (Button) {
                class Events {
                }
                Button.Events = Events;
                class EventNames {
                }
                Button.EventNames = EventNames;
            })(Button = Stepper.Button || (Stepper.Button = {}));
        })(Stepper = Controls.Stepper || (Controls.Stepper = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=stepper.js.map
